import { Component, OnInit } from '@angular/core';
import { IonRouterOutlet, IonContent } from "@ionic/angular/standalone";

@Component({
  selector: 'app-app-auth',
  templateUrl: './app-auth.component.html',
  styleUrls: ['./app-auth.component.scss'],
  imports: [IonRouterOutlet, IonContent],
})
export class AppAuthComponent  implements OnInit {

  constructor() { }

  ngOnInit() {}

}
